import { UseFormReturn } from 'react-hook-form';
import { FormValuesType } from 'src/components/CustomFields/ComposableForm';
import { CustomFieldDefinition, CustomValues } from '@alucio/aws-beacon-amplify/src/models';

export const BODY_DEFAULT_VALUE = 'The bracketed text below determines where the desired distributable file links ' +
  'will appear when this email template is shared externally. You can place the bracketed text in between paragraphs ' +
  'or anywhere within this template body area. \n\n[Files]';

export const LABELS_DESCRIPTION = 'These labels will determine which ends users have \n' +
  'access to this template based on their assign filters.';

export const BRACKETS_HELP = 'Inserting the [Files] bracketed text will determine where the desired \n' +
  'distributable file download links will appear when this email \n' +
  'template is shared externally by end users. \n\n' +
  'Inserting the [Attachments] bracketed text will determine where the \n' +
  'download links to the attachments will appear when this email \n' +
  'template is shared externally by end users. \n\n' +
  'Inserting the [Link URL] bracketed text will be replaced with the hub/document link generated. \n' +
  'Make sure you have only one instance of each in the body text area. Link URL could be used multiple times.';

export const EMAIL_PLACEHOLDER =
  'Multiple emails should be separated by commas (i.e. janesmith@email.com, johndoe@email.com)';

export const BODY_ERRORS = {
  noInstances: 'The template body needs to include [placeholder]. ' +
    'Please insert by clicking on the blue [placeholder] link.',
  manyInstances: 'The template body can only have one instance of [placeholder].',
};

export const BODY_PLACEHOLDERS = {
  files: '[Files]',
  attachments: '[Attachments]',
  linkUrl: '[Link URL]',
}

// TYPES
export enum PERFORMING_ACTION {
  ACTIVATING,
  FIRST_DRAFT,
  SAVE_EXISTING,
}

export enum SUBMITTING_STATUS {
  NONE,
  SUBMITTING,
  SUCCESS
}

/* Helper method */
export function isStringArray(value: any): value is string[] {
  return Array.isArray(value) && value.every(item => typeof item === 'string')
}
export function getFormattedLabelValues(
  rhForm: UseFormReturn<FormValuesType>,
  customFields?: CustomFieldDefinition[],
): CustomValues[] {
  const formattedValues: CustomValues[] = [];
  const formValues = rhForm.getValues()

  customFields?.forEach(({ id, fieldValueDefinitions }) => {
    const values: string[] = [];
    const formValue = formValues[id]
    if (Array.isArray(formValue) && isStringArray(formValue)) {
      formValue.forEach((labelId) => {
        const valueDefinition = fieldValueDefinitions.find(({ id }) => labelId === id);
        if (valueDefinition) {
          values.push(valueDefinition.id);
        }
      });
    }
    formattedValues.push({
      fieldId: id,
      values,
    });
  });

  return formattedValues;
}
